/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.13.2
 */
export const CSS = {
    actionBarContainer: "action-bar-container",
    content: "content",
};
export const SLOTS = {
    actionBar: "action-bar",
};
//# sourceMappingURL=resources.js.map
